import { render, staticRenderFns } from "./Tendency_overall.vue?vue&type=template&id=3f20285e&scoped=true&"
import script from "./Tendency_overall.vue?vue&type=script&lang=js&"
export * from "./Tendency_overall.vue?vue&type=script&lang=js&"
import style0 from "./Tendency_overall.vue?vue&type=style&index=0&id=3f20285e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f20285e",
  null
  
)

export default component.exports